export const CONST = {
  day: 24 * 60 * 60 * 1000,
  api_method: {
    post: 'post',
    get: 'get',
    put: 'put',
    delete: 'delete',
  },
  default_datetime_format: 'YYYY-MM-DD HH:mm:ss',
  dt_format_min: 'YYYY-MM-DD HH:mm',
  accept_album_img_exts: {
    jpg: 'image/jpeg',
    jpeg: 'image/jpeg',
    png: 'image/png',
    gif: 'image/gif',
    webp: 'image/webp',
  },
  accept_album_movie_exts: {
    mp4: 'video/mp4',
    mov: 'video/quicktime',
  },
  accept_size_mb: {
    img: 20,
    movie: 200,
    other: 10,
  },
  img_size: {
    img: 1280,
    pickup: 480,
    thumb: 160,
  },
  swiper: {
    speed: 300,
  },
  tab_ym: {
    limit: {
      min: 100001,
      max: 299912,
    },
    prepare: {
      m: 60,
      y: 20,
    },
    layout: {
      default: { m_left: 12, y_left: 65, sep_left: 52, width: 40, separator: '/' },
      en: { m_left: 16, y_left: 65, sep_left: 64, width: 52, separator: '' },
      es: { m_left: 16, y_left: 67, sep_left: 66, width: 54, separator: '' },
      pt: { m_left: 16, y_left: 65, sep_left: 64, width: 52, separator: '' },
      ru: { m_left: 12, y_left: 65, sep_left: 52, width: 40, separator: '/' },
      de: { m_left: 16, y_left: 65, sep_left: 64, width: 52, separator: '' },
      fr: { m_left: 16, y_left: 65, sep_left: 64, width: 52, separator: '' },
      it: { m_left: 16, y_left: 73, sep_left: 72, width: 60, separator: '' },
      ja: { m_left: 74, y_left: 18, sep_left: 70, width: 40, separator: '/' },
      zh_CN: { m_left: 74, y_left: 18, sep_left: 70, width: 40, separator: '/' },
      zh_TW: { m_left: 74, y_left: 18, sep_left: 70, width: 40, separator: '/' },
      vi: { m_left: 12, y_left: 65, sep_left: 52, width: 40, separator: '/' },
    },
    month_format: [
      null,
      $T('common.month.short.1') == 'common.month.short.1' ? '01' : $T('common.month.short.1'),
      $T('common.month.short.2') == 'common.month.short.2' ? '02' : $T('common.month.short.2'),
      $T('common.month.short.3') == 'common.month.short.3' ? '03' : $T('common.month.short.3'),
      $T('common.month.short.4') == 'common.month.short.4' ? '04' : $T('common.month.short.4'),
      $T('common.month.short.5') == 'common.month.short.5' ? '05' : $T('common.month.short.5'),
      $T('common.month.short.6') == 'common.month.short.6' ? '06' : $T('common.month.short.6'),
      $T('common.month.short.7') == 'common.month.short.7' ? '07' : $T('common.month.short.7'),
      $T('common.month.short.8') == 'common.month.short.8' ? '08' : $T('common.month.short.8'),
      $T('common.month.short.9') == 'common.month.short.9' ? '09' : $T('common.month.short.9'),
      $T('common.month.short.10') == 'common.month.short.10' ? '10' : $T('common.month.short.10'),
      $T('common.month.short.11') == 'common.month.short.11' ? '11' : $T('common.month.short.11'),
      $T('common.month.short.12') == 'common.month.short.12' ? '12' : $T('common.month.short.12'),
    ],
  },
  postIcons: {
    NS: '/imgs/icons-m/news.png',
    JA: '/imgs/icons-m/accept.png',
    FA: '/imgs/icons-m/accept.png',
    JI: '/imgs/icons-m/invite.png',
    FI: '/imgs/icons-m/invite.png',
    SF: '/imgs/icons-m/file.png',
    SD: '/imgs/icons-m/schedule.png',
    CA: '/imgs/icons-m/attendance.png',
    EQ: '/imgs/icons-m/enquete.png',
    CS: '/imgs/icons-m/life.png',
  },
  postIconsG: {
    NS: '/imgs/icons-m/news-g.png',
    SF: '/imgs/icons-m/file-g.png',
    SD: '/imgs/icons-m/schedule-g.png',
    CA: '/imgs/icons-m/attendance-g.png',
    EQ: '/imgs/icons-m/enquete-g.png',
    CS: '/imgs/icons-m/life-g.png',
  },
  postEnqueteTypes: {
    t: $T('post.enquete.types.free'),
    s: $T('post.enquete.types.single'),
    m: $T('post.enquete.types.multi'),
  },
  postScheduleStatus: {
    0: $T('common.no-answer'),
    1: $T('post.schedule.status.ok'),
    2: $T('post.schedule.status.soso'),
    3: $T('post.schedule.status.bad'),
  },
  postLifeStatus: {
    1: $T('post.life.status.ok'),
    2: $T('post.life.status.soso'),
    3: $T('post.life.status.bad'),
  },
  allNames: {
    A1: $T('common.community-all'),
    A2: $T('common.admin-all'),
    A3: $T('common.member-all'),
  },
  htmlEscapes: {
    '&': '&amp;',
    "'": '&#x27;',
    '`': '&#x60;',
    '"': '&quot;',
    '<': '&lt;',
    '>': '&gt;',
    '>': '&gt;',
  },
  COMMUNTIY_MEMBER_STATUS: {
    ACCEPTED: 1,
    CONFIRM_WAITING: 2,
    DENIED: 9,
    RETIRED: 10,
    BANNED: 99,
  },
  FRIEND_STATUS: {
    ACTIVE: 1,
    REQUEST: 2,
    BE_REQUESTED: 3,
    REFUSE: 4,
    BE_REFUSED: 5,
    CANCEL: 6,
    BE_CANCELED: 7,
    BAN: 8,
    BE_BANNED: 9,
  },
  COMMUNITY_ROLE: {
    OWNER: 1,
    MANAGER: 2,
    MEMBER: 3,
    GUEST: 4,
  },
  APP_TYPE: {
    POST: 'post',
    TALK: 'talk',
    ALBUM: 'album',
    CALENDAR: 'calendar',
  },
  POST_TYPE: {
    FRIEND_ACCEPTANCE: 'FA',
    FRIEND_INVITATION: 'FI',
    JOIN_INVITATION: 'JI',
    JOIN_ACCEPTANCE: 'JA',
    NEWS: 'NS',
    SCHEDULE: 'SD',
    CONFIRM_ATTENDANCE: 'CA',
    ENQUETE: 'EQ',
    CONFIRM_SAFETY: 'LF',
    SHARE_FILE: 'FL',
  },
  talk_role: {
    owner: 1,
    manager: 2,
    member: 3,
    guest: 4,
  },
  talk_type: {
    all: 1,
    public: 2,
    private: 3,
  },
  talk: {
    load_count: 20,
    collection: {
      member: 'members',
      talk_data: 'talk_data',
      talk_message: 'talk_messages',
    },
    sub_collection: {
      talk: 'talks',
      message: 'messages',
      member: 'members',
    },
  },
};
